import SettingOrganization from "../pages/CaseManagementOrganization/SettingOrganization";

export const ActionsCenterMenu = "ActionsCenter";
export const NewsfeedMenu = "NewsfeedMenu";
export const ProfileMenu = "ProfileMenu";
export const AllAppsMenu = "AllAppsMenu";
export const GroupMenu = "GroupMenu";
export const SettingMenu = "SettingMenu";
export const HomeMenu = "HomeMenu";
export const LinkPersonalMenu = "LinkPersonalMenu";
export const monthsFull = [
  "January ",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const months = [
  "Jan ",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const pathRoutes = {
  Root: "/loading",
  Privacy: "/privacy",
  HeadstartRoot: "/headstart/loading",
  UserReward: "/user-rewards",
  LoginStream: "/hstart/login",
  Login: "/login",
  Feed: "/action-center",
  Group: "/groups",
  Main: "/main",
  Apps: "/apps",
  MicroApp: "/microApp",
  MicroAppPD: "/micro-app",
  File: "/file",
  Chat: "/center-chat",
  Video: "/video",
  Example: "/citizenprofile",
  Home: "/home",
  Post: "/posts",
  Profile: "/profile",
  Setting: "/setting",
  Link: "/link",
  createGroup: "/createGroup",
  createAccount: "/createAccount",
  addFile: "/addFile",
  conference: "/conference",
  personalCall: "/personal-call",
  checkIn: "/checkIn",
  Live: "/live",
  PersonalLive: "/personal-live",
  GroupLive: "/group-live",
  Stream: "/headstart",
  StreamAdmin: "/streamAdmin",
  StreamSeeMore: "/streamSeeMore",
  StreamForUser: "/streamForUser",
  forgotPassword: "/forgot-password",
  citizenprofile: "/citizenprofile",
  centercitizenprofile: "/center-citizenprofile",
  headstartinfo: "/headstart-live",
  headstartwatch: "/headstart-watch",
  fileCheckAccess: "/file-access",
  groupCommunity: "/group-community",
  groupCommunityPath: "/group-community/:id",
  conferenceOptions: "/conference-options",
  InitHeadStart: "/init-head-start",
  VirtualBackground: "/virtual-background",
  Board: "/whiteboard",
  googleLogin: "/auth/google",
  facebookLogin: "/auth/facebook",
  azureLogin: "/auth/azure",
  DraggableBoard: "/mention",
  Custom: "/custom/:key",
  CustomMenu : "/custom",
  UICaseDesignMaster : "/case-design-master",
  NewDocument : "/document-pages",
  NewDocumentPath : "/document-pages/id/:id",
  HomeCaseManagement:"/home-case-management",
  SettingCaseManagement:"/setting-case-management",
  ViewAllDocuments:"/view-all-documents",
  CaseDetails:"/case-details",
  CaseDetailsPath:"/case-details/:id",
  Template: "/template",
  TemplateInfo: "/TemplateInfo",
  TemplateInfoPath: "/TemplateInfo"+ "/id/:id",
  Rule: "/rule-condition-master",
  SettingRule: "/rule-setting",
  SettingRulePath: "/rule-setting/:id",
  Integration: "/integration",
  SettingIntegration: "/integration-setting",
  SettingIntegrationPath: "/integration-setting/:id",
  Organization: "/organization",
  SettingOrganization: "/organization-setting",
  SettingOrganizationPath: "/organization-setting" + "/:id"
};

export const mainState = {
  init: "init",
  RSA_2048: "RSA_2048",
};

export const permFile = {
  anyoneWithTheLink: "anyoneWithTheLink",
  restricted: "restricted",
};

export const mainTab = {
  files: "files",
  medias: "medias",
  links: "links",
  menu: "menu",
};
export const constKey = {
  myId: "my-id",
};
export const chatContent = {
  history: "history",
  content: "content",
};
export const nodataFile = {
  noDataHeaderFileText: "No file available",
  nodataFiletextH: "When upload file",
  nodataFiletextL: "they'll appear on your file pages",

  noDataHeaderDirText: "No folder available",
  nodataDirtextH: "When create folder",
  nodataDirtextL: "they'll appear on your folder pages",

  noDataHeaderTextTrash: "No file or folder available",
  nodatatextTrashH: "When delete file or folder",
  nodatatextTrashL: "they'll appear on your trash",

  noDataHeaderTextGroup: "No group available",
  nodatatextGroupH: "When join group",
  nodatatextGroupL: "they'll appear on your groups",

  noDataHeaderTextLink: "No link available",
  nodatatextLinkH: "When send link to chat",
  nodatatextLinkL: "they'll appear on your links",
};

export const videoType = [
  "m4v",
  "avi",
  "mpg",
  "mp4",
  "webm",
  "mov",
  "M4A",
  "M4V",
  "AVI",
  "MPG",
  "MP4",
  "WEBM",
  "MOV",
];

export const imgTypes = [
  "JPEG",
  "JPG",
  "JPEG",
  "GIF",
  "BMP",
  "360-DEGREE",
  "PNG",
  "360-DEGREE",
  "JPEG",
  "JPG",
  "JPEG",
  "GIF",
  "BMP",
  "360-DEGREE",
  "PNG",
  "360-DEGREE",
  "jpeg",
  "jpg",
  "jpeg",
  "gif",
  "bmp",
  "360-degree",
  "png",
  "360-degree",
  "jpeg",
  "jpg",
  "jpeg",
  "gif",
  "bmp",
  "360-degree",
  "png",
  "360-degree",
];

export const cz_scripts = [
  "/runtime-es2015.js",
  "/runtime-es5.js",
  "/polyfills-es5.js",
  "/polyfills-es2015.js",
  "/scripts.js",
  "/5-es5.js",
  "/main-es2015.js",
  "/main-es5.js",
];

export const cz_script_objects = [
  {
    //1
    key: "cz-runtime-es2015",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/runtime-es2015.js",
  },
  {
    //2
    key: "cz-runtime-es5",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/runtime-es5.js",
  },
  {
    //3
    key: "cz-polyfills-es5",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/polyfills-es5.js",
  },
  {
    //4
    key: "cz-polyfills-es2015",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/polyfills-es2015.js",
  },
  {
    //5
    key: "cz-scripts",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/scripts.js",
  },
  { 
    //6
    key: "cz-5-es5", url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/5-es5.js" },
  {
    //7
    key: "cz-main-es2015",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/main-es2015.js",
  },
  {
    //8
    key: "cz-main-es5",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/main-es5.js",
  },
  {
    //9
    key: "cz-7-es2015",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/7-es2015.js",
  },
  {
    //10
    key: "cz-6-es2015",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/6-es2015.js",
  }, {
    //11
    key: "styles.css",
    url: window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL + "/styles.css",
    type:"css"
  },
];
